import {jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const ArrowDropDown = ({className, ...props}) => (
  _jsx('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: 
    _jsx('path', { d: "m7 10 5 5 5-5z"    ,} )
  })
)

export default ArrowDropDown
